'use client'

import Text from '@/components/custom-ui/text'
import React from 'react'
import RichText from '@/components/custom-ui/rich-text'
import useErrorPage from './error.hooks'
import { useDictionary } from './error.dictionary'
export default function GlobalError() {
  const { data, isLoading } = useErrorPage()
  const dict = useDictionary()

  if (isLoading) return null

  const bgImage =
    data?.background_image.data.attributes.url || '/images/error-bg.jpg'

  return (
    <div
      className="h-screen w-full bg-cover bg-center"
      style={{
        backgroundImage: `url(${bgImage})`,
      }}
    >
      <div className="container flex h-full max-w-[calc(646/16*1rem)] items-center justify-center px-5 sm:px-0">
        <div className="w-full bg-white/60 px-4 py-8 text-center backdrop-blur-md sm:px-8 sm:py-11">
          <div className="container flex max-w-[calc(573/16*1rem)] flex-col items-center justify-center gap-4">
            <Text as="h2" className="uppercase">
              {data?.title || dict.title}
            </Text>
            {data?.explanation ? (
              <RichText content={data?.explanation} />
            ) : (
              dict.description
            )}
          </div>
        </div>
      </div>
    </div>
  )
}
